import gql from 'graphql-tag'

export const QUERY_SALES_CAMPAIGN_BY_ID = gql`
  query OfferSchedule($id: String!, $franchise: Boolean) {
    offerSchedule(_id: $id, franchise: $franchise) {
      _id
      active
      status
      name
      origin
      description
      start_date
      end_date
      start_time
      end_time
      created_at
      updated_at
      activatable
      has_results
      products_count
      types
      flash
      pdv_margin_time
      communication {
        default {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
            message
          }
        }
        next_buy_cashback {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
            message
          }
        }
        digital_voucher {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
            message
          }
        }
      }
      industry {
        _id
        name
        proposal_deadline
        is_mercapromo
        available_units
        acceptance {
          date
          terms
          image
        }
        accept_history {
          date
          user {
            name
            login
          }
        }
      }
      rules {
        key
        editable
      }
      units {
        _id
        name
        id_erp
        dataType
        cnpj
        ecommerce_partner {
          partner_unit_id
        }
      }
      campaigns {
        _id
        title
        mode
        message {
          send_date
          text
          ... on SalesPushChannelCampaignMessage {
            title
          }
        }
      }
      offer_sales {
        ... on OfferSale {
          sku
          name
          active
          ean
          eans
          price_1
          price_2
          price_base_industry
          rebate
          minimum_per_client
          maximum_per_client
          image_url
          label_pdv
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesGroup {
          _id
          name
          price_1
          price_2
          price_base_industry
          rebate
          minimum_per_client
          maximum_per_client
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          offer_sales {
            name
            sku
            active
            finalized
            ean
            eans
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      percentage_offer_sales {
        ... on OfferSalePercentage {
          name
          sku
          active
          ean
          eans
          percentage_discount
          maximum_per_client
          minimum_per_client
          image_url
          label_pdv
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesPercentageGroup {
          _id
          name
          percentage_discount
          maximum_per_client
          minimum_per_client
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          percentage_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      dynamic_pricing_percentage_offer_sales {
        ... on OfferSaleDynamicPricingPercentage {
          name
          sku
          active
          ean
          eans
          product {
            image
            sku
            ean
            eans
            name
          }
          image_url
          maximum_per_client
          minimum_per_client
          percentage_discount
        }
        ... on OfferSalesDynamicPricingPercentageGroup {
          _id
          name
          percentage_discount
          maximum_per_client
          minimum_per_client
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          dynamic_pricing_percentage_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      cashback_percentage_offer_sales {
        ... on OfferSaleCashbackPercentage {
          name
          sku
          active
          ean
          eans
          price_1
          cashback_percentage
          maximum_per_client
          minimum_per_client
          image_url
          label_pdv
          expiration_cashback {
            expiration_in_days
            expires_at
            type
          }
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesCashbackPercentageGroup {
          _id
          name
          price_1
          cashback_percentage
          maximum_per_client
          minimum_per_client
          group_image_url
          group_rules_exhibition
          expiration_cashback {
            expiration_in_days
            expires_at
            type
          }
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          cashback_percentage_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      cashback_absolute_offer_sales {
        ... on OfferSaleCashbackAbsolute {
          name
          sku
          active
          ean
          eans
          price
          cashback_absolute
          maximum_per_client
          minimum_per_client
          image_url
          label_pdv
          expiration_cashback {
            expiration_in_days
            expires_at
            type
          }
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesCashbackAbsoluteGroup {
          _id
          name
          price
          cashback_absolute
          maximum_per_client
          minimum_per_client
          group_image_url
          group_rules_exhibition
          expiration_cashback {
            expiration_in_days
            expires_at
            type
          }
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          cashback_absolute_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      points_offer_sales {
        ... on OfferSalePoints {
          name
          sku
          active
          ean
          eans
          price
          additional_points_rate
          maximum_per_client
          minimum_per_client
          image_url
          label_pdv
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesPointsGroup {
          _id
          name
          price
          additional_points_rate
          maximum_per_client
          minimum_per_client
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          points_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      takepay_offer_sales {
        ... on OfferSaleTakeAndPay {
          name
          sku
          active
          ean
          eans
          take
          pay
          maximum_per_client
          image_url
          label_pdv
          product {
            _id
            image
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSalesTakeAndPayGroup {
          _id
          name
          take
          pay
          maximum_per_client
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          takepay_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            label_pdv
            product {
              _id
              image
              eans
              ean
            }
          }
        }
      }
      combo_offer_sales {
        name
        image
        combo_id
        maximum_per_client
        active
        label_pdv
        trigger_products {
          ... on TriggerProduct {
            quantity
            name
            sku
            ean
            eans
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on TriggerProductGroup {
            _id
            name
            quantity
            trigger_products {
              name
              sku
              ean
              eans
              product {
                _id
                sku
                ean
                eans
                name
              }
            }
          }
        }
        target_products {
          ... on TargetProduct {
            percentage_discount
            name
            sku
            ean
            eans
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on TargetProductGroup {
            _id
            name
            percentage_discount
            target_products {
              name
              sku
              ean
              eans
            }
          }
        }
      }
      next_buy_cashback_offer_sales {
        ... on OfferSaleNextBuyCashback {
          sku
          ean
          eans
          name
          active
          image_url
          label_pdv
          max_coupons
          minimum_per_client
          cashback_absolute_discount
          cashback_expiration_date
          price
          product {
            _id
            sku
            ean
            eans
            name
          }
        }
        ... on OfferSaleNextBuyCashbackGroup {
          _id
          name
          minimum_per_client
          cashback_absolute_discount
          cashback_expiration_date
          max_coupons
          group_image_url
          group_rules_exhibition
          group_categories_final_consumer {
            department_id
            category_id
            sub_category_id
          }
          next_buy_cashback_offer_sales {
            sku
            ean
            eans
            name
            active
            image_url
            label_pdv
            product {
              sku
              ean
              eans
              name
            }
          }
        }
      }
      dynamic_rule_offer_sales {
        active
        label_pdv
        trigger_products {
          active
          sku
          ean
          eans
          name
          equivalent_quantity
          group_id
          group_name
          group_rules_exhibition
          image_url
        }
        target_rules {
          type
          mode
          topic
        }
        trigger_rules {
          maximum_per_client
          trigger_amount
          operator
          group_operator
          trigger_mode
        }
        benefits {
          type
          value
          minu_prize
          voucher_provider
        }
        vouchers
      }
      cross_sell_offer_sales {
        active
        label_pdv
        trigger_products {
          active
          sku
          ean
          eans
          name
          equivalent_quantity
          group_id
          group_name
          group_rules_exhibition
          image_url
        }
        trigger_rules {
          maximum_per_client
          trigger_amount
          operator
          group_operator
          trigger_mode
        }
        target_products {
          active
          sku
          ean
          eans
          name
          group_id
          group_name
          group_rules_exhibition
          image_url
        }
        target_rules {
          type
          discount
        }
      }
      segments {
        _id
        name
        description
        campaign_qty
        clients_qty
        clients_qty_at_campaign
        clients_refreshed_at
        fixed
      }
      has_segment_data
      channel_configuration {
        platform
        ecommerce
      }
      is_featured
    }
  }
`

export const QUERY_SALES_CAMPAIGN_RESULTS_BY_ID = gql`
  query OfferScheduleResultsById($id: String!, $franchise: Boolean) {
    offerSchedule(_id: $id, franchise: $franchise) {
      _id
      flash
      active
      status
      name
      origin
      description
      start_date
      end_date
      start_time
      end_time
      created_at
      updated_at
      activatable
      has_results
      types
      communication {
        default {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
          }
        }
        next_buy_cashback {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
          }
        }
        digital_voucher {
          sms {
            active
            message
          }
          whatsapp {
            active
            template
            placeholders
            from_number
          }
        }
      }
      industry {
        name
        proposal_deadline
        is_mercapromo
      }
      units {
        _id
        name
        id_erp
        dataType
        ecommerce_partner {
          partner_type
          partner_unit_id
        }
      }
      offer_sales {
        ... on OfferSale {
          sku
          name
          image_url
        }
        ... on OfferSalesGroup {
          name
          offer_sales {
            name
            sku
            image_url
          }
        }
      }
      percentage_offer_sales {
        ... on OfferSalePercentage {
          name
          sku
          image_url
        }
        ... on OfferSalesPercentageGroup {
          name
          percentage_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      dynamic_pricing_percentage_offer_sales {
        ... on OfferSaleDynamicPricingPercentage {
          name
          sku
          image_url
        }
        ... on OfferSalesDynamicPricingPercentageGroup {
          name
          dynamic_pricing_percentage_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      cashback_percentage_offer_sales {
        ... on OfferSaleCashbackPercentage {
          name
          sku
          image_url
          expiration_cashback {
            type
            expires_at
            expiration_in_days
          }
        }
        ... on OfferSalesCashbackPercentageGroup {
          name
          cashback_percentage_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      takepay_offer_sales {
        ... on OfferSaleTakeAndPay {
          name
          sku
          image_url
        }
        ... on OfferSalesTakeAndPayGroup {
          name
          takepay_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      cashback_absolute_offer_sales {
        ... on OfferSaleCashbackAbsolute {
          name
          sku
          image_url
          expiration_cashback {
            type
            expires_at
            expiration_in_days
          }
        }
        ... on OfferSalesCashbackAbsoluteGroup {
          name
          cashback_absolute_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      points_offer_sales {
        ... on OfferSalePoints {
          name
          sku
          image_url
        }
        ... on OfferSalesPointsGroup {
          name
          points_offer_sales {
            name
            sku
            image_url
          }
        }
      }
      combo_offer_sales {
        name
        active
        combo_id
        trigger_products {
          ... on TriggerProduct {
            name
            sku
          }
          ... on TriggerProductGroup {
            name
            trigger_products {
              name
              sku
            }
          }
        }
        target_products {
          ... on TargetProduct {
            name
            sku
          }
          ... on TargetProductGroup {
            name
            target_products {
              name
              sku
            }
          }
        }
      }
      next_buy_cashback_offer_sales {
        ... on OfferSaleNextBuyCashback {
          name
          sku
          image_url
          cashback_expiration_date
        }
      }
      dynamic_rule_offer_sales {
        benefits {
          type
        }
        trigger_products {
          ... on SaleTriggerProductDynamicRule {
            name
            sku
            image_url
          }
        }
      }
      cross_sell_offer_sales {
        trigger_products {
          sku
          ean
          name
          image_url
        }
        target_products {
          sku
          ean
          name
        }
      }
      benefits_offer_sales {
        trigger_products {
          sku
          name
          image_url
        }
        coupons {
          code
          image
          discount
        }
      }
      segments {
        _id
        name
        clients_qty_at_campaign
      }
      has_segment_data
      month_metrics(franchise: $franchise) {
        month
        metrics {
          benefits {
            ...metricsData
          }
        }
        unit_metrics {
          unit_name
          metrics {
            benefits {
              ...metricsData
            }
          }
        }
      }
      metrics(franchise: $franchise) {
        general {
          ...metricsData
        }
        percentage {
          ...metricsData
        }
        takepay {
          ...metricsData
        }
        combo {
          ...metricsData
        }
        cashback_absolute {
          ...metricsData
        }
        cashback_percentage {
          ...metricsData
        }
        points {
          ...metricsData
        }
        nextbuycashback {
          ...metricsData
        }
        dynamic_rule {
          ...metricsData
        }
        crosssell {
          ...metricsData
        }
        dynamic_pricing_percentage {
          ...metricsData
        }
      }
      reference_period_metrics {
        start_date
        end_date
      }
      unit_metrics(franchise: $franchise) {
        unit_name
        metrics {
          general {
            ...metricsData
          }
          percentage {
            ...metricsData
          }
          combo {
            ...metricsData
          }
          cashback_absolute {
            ...metricsData
          }
          cashback_percentage {
            ...metricsData
          }
          points {
            ...metricsData
          }
          takepay {
            ...metricsData
          }
          nextbuycashback {
            ...metricsData
          }
          dynamic_rule {
            ...metricsData
          }
          crosssell {
            ...metricsData
          }
          dynamic_pricing_percentage {
            ...metricsData
          }
        }
      }
      expiration_cashback {
        expiration_in_days
        expires_at
        type
      }
    }
  }

  fragment metricsData on OfferScheduleMetrics {
    offers_metrics {
      revenue
      discounts
      revenue_without_discount
    }
    first_purchase_metrics {
      count_total
      count_with_sales
    }

    clients_metrics {
      total {
        revenue
        count
        tickets
        average_ticket
      }
      with_activated_sales {
        revenue
        count
        tickets
        average_ticket
      }
      with_sales {
        revenue
        count
        tickets
        average_ticket
      }
      with_only_sales {
        revenue
        count
        tickets
        average_ticket
      }
    }

    products_metrics {
      ...productMetrics
    }

    products_target_metrics {
      ...productMetrics
    }

    products_trigger_metrics {
      ...productMetrics
    }

    eligible_metrics {
      quantity
      clients
      tickets
      loyalty_tickets
      loyalty_quantity
    }

    burn_metrics {
      clients
      count
      tickets
      total_value
    }

    earn_metrics {
      clients
      count
      tickets
      total_value
    }

    eligible_with_target_metrics {
      clients
      quantity
      tickets
    }

    benefits_metrics_table_activated {
      table {
        _id
        activated {
          clients
          discounts
          revenue
          quantity
          tickets
        }
      }
    }

    benefits_metrics_totals_activated {
      clients
      discounts
      quantity
      revenue
      tickets
    }

    benefits_metrics_totals_consumed {
      clients
      discounts
      quantity
      tickets
      revenue
    }

    benefits_metrics_table_consumed {
      table {
        _id
        consumed {
          clients
          discounts
          revenue
          quantity
          tickets
        }
      }
    }
  }

  fragment productMetrics on OfferScheduleMetricsProducts {
    table {
      product(franchise: $franchise) {
        sku
        name
      }
      reference {
        clients
        revenue
        discounts
        quantity
        tickets
      }
      total {
        loyalty_quantity
        loyalty_tickets
        clients
        activated_clients
        revenue
        discounts
        quantity
        tickets
        points
        cashback
      }
      sales {
        loyalty_quantity
        loyalty_tickets
        clients
        activated_clients
        revenue
        discounts
        offers_schedule_discounts
        quantity
        tickets
        points
        cashback
        rebate
        average_discount
      }
      eligible {
        quantity
        clients
        tickets
      }
      burn {
        clients
        count
        tickets
        total_value
      }
      earn {
        clients
        count
        tickets
        total_value
      }
    }
    totals {
      reference {
        clients
        revenue
        discounts
        quantity
        tickets
      }
      total {
        loyalty_quantity
        loyalty_tickets
        clients
        activated_clients
        revenue
        discounts
        quantity
        tickets
        points
        cashback
      }
      sales {
        loyalty_quantity
        loyalty_tickets
        clients
        activated_clients
        revenue
        discounts
        offers_schedule_discounts
        quantity
        tickets
        points
        cashback
        average_discount
        rebate
      }
    }
  }
`

export const QUERY_SALES_STATUS_CAMPAIGN_BY_ID = gql`
  query OfferScheduleStatusById($id: String!) {
    offerSchedule(_id: $id) {
      status
      has_results
    }
  }
`

export const QUERY_VALIDATE_IMPORTED_PRODUCTS = gql`
  query ValidateImportedProducts($ids: [String], $search: String, $eans: [String], $skus: [String], $active: Boolean, $units: [String]) {
    products(ids: $ids, search: $search, eans: $eans, skus: $skus, active: $active, units: $units) {
      products {
        _id
        sku
        ean
        eans
        name
        image
        units_with_price_1
      }
    }
  }
`

export const QUERY_LIST_SALES_CAMPAIGNS = gql`
  query ListOfferSchedulesCampaigns(
    $status: [String]
    $search: String
    $page: Int
    $pageSize: Int
    $format: [String]
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [String]
    $units_configuration: [UnitConfigurationInput]
    $franchise: Boolean
    $includeAuto: Boolean
    $industry: Boolean
    $offerIds: [String]
    $products: [String]
    $modality: [String]
    $personalized: Boolean
    $industryIds: [ID]
  ) {
    offerSchedules(
      status: $status
      search: $search
      page: $page
      pageSize: $pageSize
      format: $format
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      units_configuration: $units_configuration
      franchise: $franchise
      include_auto: $includeAuto
      industry: $industry
      offerIds: $offerIds
      products: $products
      modality: $modality
      personalized: $personalized
      industryIds: $industryIds
    ) {
      offerSchedules {
        _id
        active
        status
        name
        flash
        activatable
        description
        start_date
        end_date
        start_time
        end_time
        created_at
        updated_at
        products_count
        types
        has_results
        personalized
        industry {
          name
          proposal_deadline
          is_mercapromo
        }
        units {
          _id
          id_erp
          name
        }
        loyalty
        segments {
          name
        }
        omni_campaigns {
          _id
        }
        types
        offer_sales {
          ... on OfferSale {
            sku
            name
            active
            ean
            eans
            price_1
            price_2
            price_base_industry
            rebate
            minimum_per_client
            maximum_per_client
            image_url
            label_pdv
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesGroup {
            _id
            name
            price_1
            price_2
            price_base_industry
            minimum_per_client
            maximum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            offer_sales {
              name
              sku
              active
              finalized
              ean
              eans
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        percentage_offer_sales {
          ... on OfferSalePercentage {
            name
            sku
            active
            ean
            eans
            percentage_discount
            maximum_per_client
            minimum_per_client
            image_url
            label_pdv
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesPercentageGroup {
            _id
            name
            percentage_discount
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        dynamic_pricing_percentage_offer_sales {
          ... on OfferSaleDynamicPricingPercentage {
            name
            sku
            active
            ean
            eans
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
            image_url
            maximum_per_client
            minimum_per_client
            percentage_discount
          }
          ... on OfferSalesDynamicPricingPercentageGroup {
            _id
            name
            percentage_discount
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            dynamic_pricing_percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        cashback_percentage_offer_sales {
          ... on OfferSaleCashbackPercentage {
            name
            sku
            active
            ean
            eans
            price_1
            cashback_percentage
            maximum_per_client
            minimum_per_client
            image_url
            label_pdv
            expiration_cashback {
              expiration_in_days
              expires_at
              type
            }
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesCashbackPercentageGroup {
            _id
            name
            price_1
            cashback_percentage
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            expiration_cashback {
              expiration_in_days
              expires_at
              type
            }
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            cashback_percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        cashback_absolute_offer_sales {
          ... on OfferSaleCashbackAbsolute {
            name
            sku
            active
            ean
            eans
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            image_url
            label_pdv
            expiration_cashback {
              expiration_in_days
              expires_at
              type
            }
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesCashbackAbsoluteGroup {
            _id
            name
            price
            cashback_absolute
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            expiration_cashback {
              expiration_in_days
              expires_at
              type
            }
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            cashback_absolute_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        points_offer_sales {
          ... on OfferSalePoints {
            name
            sku
            active
            ean
            eans
            price
            additional_points_rate
            maximum_per_client
            minimum_per_client
            image_url
            label_pdv
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesPointsGroup {
            _id
            name
            price
            additional_points_rate
            maximum_per_client
            minimum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            points_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        takepay_offer_sales {
          ... on OfferSaleTakeAndPay {
            name
            sku
            active
            ean
            eans
            take
            pay
            maximum_per_client
            image_url
            label_pdv
            product(franchise: $franchise) {
              _id
              image
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSalesTakeAndPayGroup {
            _id
            name
            take
            pay
            maximum_per_client
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            takepay_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              label_pdv
              product(franchise: $franchise) {
                _id
                image
                eans
                ean
              }
            }
          }
        }
        combo_offer_sales {
          name
          image
          combo_id
          maximum_per_client
          active
          label_pdv
          trigger_products {
            ... on TriggerProduct {
              quantity
              name
              sku
              ean
              eans
              product(franchise: $franchise) {
                _id
                sku
                ean
                eans
                name
              }
            }
            ... on TriggerProductGroup {
              _id
              name
              quantity
              trigger_products {
                name
                sku
                ean
                eans
                product(franchise: $franchise) {
                  _id
                  sku
                  ean
                  eans
                  name
                }
              }
            }
          }
          target_products {
            ... on TargetProduct {
              percentage_discount
              name
              sku
              ean
              eans
              product(franchise: $franchise) {
                _id
                sku
                ean
                eans
                name
              }
            }
            ... on TargetProductGroup {
              _id
              name
              percentage_discount
              target_products {
                name
                sku
                ean
                eans
                product(franchise: $franchise) {
                  _id
                  sku
                  ean
                  eans
                  name
                }
              }
            }
          }
        }
        next_buy_cashback_offer_sales {
          ... on OfferSaleNextBuyCashback {
            sku
            ean
            eans
            name
            active
            image_url
            label_pdv
            max_coupons
            minimum_per_client
            cashback_absolute_discount
            cashback_expiration_date
            price
            product(franchise: $franchise) {
              _id
              sku
              ean
              eans
              name
            }
          }
          ... on OfferSaleNextBuyCashbackGroup {
            _id
            name
            minimum_per_client
            cashback_absolute_discount
            cashback_expiration_date
            max_coupons
            group_image_url
            group_rules_exhibition
            group_categories_final_consumer {
              department_id
              category_id
              sub_category_id
            }
            next_buy_cashback_offer_sales {
              sku
              ean
              eans
              name
              active
              image_url
              label_pdv
              product(franchise: $franchise) {
                sku
                ean
                eans
                name
              }
            }
          }
        }
        dynamic_rule_offer_sales {
          active
          label_pdv
          trigger_products {
            active
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            group_rules_exhibition
            image_url
          }
          target_rules {
            type
            mode
            topic
          }
          trigger_rules {
            maximum_per_client
            trigger_amount
            operator
            group_operator
            trigger_mode
          }
          benefits {
            type
            value
            minu_prize
            voucher_provider
          }
          vouchers
        }
        cross_sell_offer_sales {
          active
          label_pdv
          trigger_products {
            active
            sku
            ean
            eans
            name
            equivalent_quantity
            group_id
            group_name
            group_rules_exhibition
            image_url
          }
          trigger_rules {
            maximum_per_client
            trigger_amount
            operator
            group_operator
            trigger_mode
          }
          target_products {
            active
            sku
            ean
            eans
            name
            group_id
            group_name
            group_rules_exhibition
            image_url
          }
          target_rules {
            type
            discount
          }
        }
      }
      records
      page
    }
  }
`

export const QUERY_LIST_SALES_CAMPAIGNS_OF_TABLE = gql`
  query ListOfferSchedulesCampaigns(
    $status: [String]
    $search: String
    $page: Int
    $pageSize: Int
    $format: [String]
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [String]
    $units_configuration: [UnitConfigurationInput]
    $franchise: Boolean
    $includeAuto: Boolean
    $industry: Boolean
    $offerIds: [String]
    $products: [String]
    $modality: [String]
    $personalized: Boolean
    $industryIds: [ID]
  ) {
    offerSchedules(
      status: $status
      search: $search
      page: $page
      pageSize: $pageSize
      format: $format
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      units_configuration: $units_configuration
      franchise: $franchise
      include_auto: $includeAuto
      industry: $industry
      offerIds: $offerIds
      products: $products
      modality: $modality
      personalized: $personalized
      industryIds: $industryIds
    ) {
      offerSchedules {
        _id
        active
        status
        name
        activatable
        description
        start_date
        end_date
        created_at
        updated_at
        products_count
        types
        has_results
        personalized
        industry {
          name
          proposal_deadline
          is_mercapromo
        }
        units {
          name
        }
        loyalty
        segments {
          name
        }
        omni_campaigns {
          _id
        }
        types
      }
      records
      page
    }
  }
`

export const QUERY_CONSUMED_SALES = gql`
  query GetConsumedSales(
    $id: ID!
    $search: String
    $page: Int!
    $pageSize: Int!
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [String]
    $units_configuration: [UnitConfigurationInput]
    $type: [OffersType]
    $status: [StatusConsumedSalesEnum]
  ) {
    consumedSales(
      offers_schedule_id: $id
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sort_direction: $sortDirection
      units: $units
      units_configuration: $units_configuration
      type: $type
      status: $status
    ) {
      records
      consumedSales {
        _id
        sale_id
        offers_schedule_id
        processed_coupon_id
        processed_coupon_status
        product {
          _id
          name
          sku
          ean
          eans
        }
        user {
          _id
          points {
            total
          }
          document_no
          name
        }
        unit {
          _id
          name
          id_erp
        }
        quantity
        total_value
        total_value_with_discount
        activated_at
        consumed_at
        consumed_sale
      }
    }
  }
`

export const MUTATION_SEND_CAMPAIGN = gql`
  mutation CreateOffersScheduleReport(
    $offersScheduleId: ID!
    $emails: [String!]!
    $groupers: [ExportGrouper!]!
    $fields: [ExportField!]!
    $franchise: Boolean
    $offerType: OfferTypes!
    $fileFormat: FileFormatType
  ) {
    createOffersScheduleReport(
      offersScheduleId: $offersScheduleId
      emails: $emails
      groupers: $groupers
      fields: $fields
      franchise: $franchise
      offerType: $offerType
      fileFormat: $fileFormat
    ) {
      fileUrl
      id
      payload {
        emails
        fields
        franchise
        groupers
        offersScheduleId
        fileFormat
      }
    }
  }
`

export const QUERY_SMS_BY_CAMPAIGN_ID = gql`
  query SmsCampaignsById($id: ID!, $mode: [CampaignModeEnum], $isIndustry: Boolean) {
    campaigns(offersScheduleId: $id, mode: $mode, isIndustry: $isIndustry) {
      campaigns {
        message {
          text
          send_date
          send_time
        }
      }
    }
  }
`

export const MUTATION_UPSERT_SALES_CAMPAIGN = gql`
  mutation UpsertOfferSchedule($data: InputOfferSchedule!) {
    upsertOfferSchedule(data: $data) {
      _id
      process_time_estimation
      error_metadata {
        message
        error_code
      }
      products_availability_erp_offers {
        unavailable_products
      }
    }
  }
`
export const MUTATION_UPSERT_DRAFT_SALES_CAMPAIGN = gql`
  mutation UpsertDraftOfferSchedule($data: InputDraftOfferSchedule!) {
    upsertDraftOfferSchedule(data: $data)
  }
`
export const MUTATION_UNSCHEDULED_SALES_CAMPAIGN = gql`
  mutation UnscheduleOfferSchedule($id: ID!) {
    unscheduleOfferSchedule(_id: $id)
  }
`
export const MUTATION_FINISH_SALES_CAMPAIGN = gql`
  mutation FinishActiveOfferSchedule($id: ID!) {
    finishActiveOfferSchedule(_id: $id)
  }
`
export const MUTATION_DELETE_SALES_CAMPAIGN = gql`
  mutation DeleteOfferSchedule($id: ID!) {
    deleteOfferSchedule(_id: $id)
  }
`
export const MUTATION_CLONE_SALES_CAMPAIGN = gql`
  mutation CloneOfferSchedule($id: ID!) {
    cloneOfferSchedule(_id: $id)
  }
`
export const MUTATION_SAVE_CRITERIA_ON_OFFER_SCHEDULE = gql`
  mutation SaveCriteriaOnOfferSchedule($input: InputSaveSegment!) {
    saveCriteriaOnOfferSchedule(input: $input)
  }
`

export const OFFER_SCHEDULE_UPDATE_SUBSCRIPTION = 'subscription OffersScheduleUpdate {\n  offersScheduleUpdate {\n    offerScheduleId\n    status\n  }\n}'

export const MUTATION_EXPORT_CONSUMED_SALES_REPORT = gql`
  mutation CreateConsumedSalesReport(
    $emails: [String!]!
    $offersScheduleId: ID!
    $salesType: [ConsumedSalesSaleTypes!]!
    $units: [String!]!
    $unitsConfiguration: [UnitConfigurationInput!]!
  ) {
    createConsumedSalesReport(
      emails: $emails
      offersScheduleId: $offersScheduleId
      salesType: $salesType
      units: $units
      unitsConfiguration: $unitsConfiguration
    ) {
      fileUrl
      id
      state
      payload {
        emails
        offersScheduleId
        salesType
        units
        unitsConfiguration {
          dataType
          value
        }
      }
    }
  }
`

export const SEND_FRANCHISEE_PRODUCTS_EANS_FREQUENCY_REPORT = gql`
  mutation CreateFranchiseeProductsEansFrequencyReport($eans: [String!]!, $emails: [String!]!, $fileFormat: FileFormatType, $units: [String!]) {
    createFranchiseeProductsEansFrequencyReport(eans: $eans, emails: $emails, fileFormat: $fileFormat, units: $units) {
      id
      payload {
        eans
        emails
        fileFormat
        units
      }
      state
    }
  }
`

export const QUERY_PRODUCTS_FRANCHISEE_PERCENTAGE = gql`
  query Products($search: String, $eans: [String], $skus: [String], $units: [String]) {
    products(search: $search, eans: $eans, skus: $skus, units: $units) {
      products {
        _id
        sku
        ean
        eans
        name
        franchisee_eans_frequency_percentage
      }
    }
  }
`

export const MUTATION_RESEND_ASYNC_JOB = gql`
  mutation CreateSalesReport(
    $emails: [String!]!
    $activeAt: SalesPeriodInput
    $endedAt: SalesPeriodInput
    $fileFormat: FileFormatType
    $startedAt: SalesPeriodInput
  ) {
    createSalesReport(emails: $emails, activeAt: $activeAt, endedAt: $endedAt, fileFormat: $fileFormat, startedAt: $startedAt) {
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`

export const QUERY_GET_KPI_METRICS = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!, $units: [ID], $products: [String]) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate, units: $units, productIds: $products) {
      revenue {
        value
        date
      }
      total_coupons {
        value
        date
      }
      unique_customers {
        value
        date
      }
      total_items {
        value
        date
      }
    }
  }
`

export const QUERY_GET_KPI_METRICS_BY_PRODUCTS = gql`
  query MetricsKpiByProducts($initialDate: String!, $finalDate: String!, $units: [ID], $products: [String]) {
    metricsKpiByProducts(initialDate: $initialDate, finalDate: $finalDate, units: $units, productIds: $products) {
      product {
        sku
        name
      }
      metrics {
        revenue {
          value
          date
        }
        total_coupons {
          value
          date
        }
        unique_customers {
          value
          date
        }
        total_items {
          value
          date
        }
      }
    }
  }
`
